import { cx } from '../../cx'

export interface RingGaugeProps {
  /** 0..1 */
  value: number
  size?: number
  strokeWidth?: number
  color?: string
  trackColor?: string
  className?: string
  /** Center content (value readout). */
  children?: React.ReactNode
}

/** Radial capacity gauge — the classic HUD instrument, for license/storage/quota. */
export function RingGauge({
  value,
  size = 96,
  strokeWidth = 5,
  color = 'var(--bui-accent)',
  trackColor = 'var(--bui-border)',
  className,
  children,
}: RingGaugeProps) {
  const clamped = Math.max(0, Math.min(1, value))
  const r = (size - strokeWidth) / 2
  const c = 2 * Math.PI * r
  return (
    <div className={cx('bui-ring', className)} style={{ width: size, height: size }}>
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} aria-hidden="true" focusable="false">
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke={trackColor} strokeWidth={strokeWidth} />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="none"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeDasharray={`${c * clamped} ${c}`}
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
          style={{ transition: 'stroke-dasharray var(--bloo-dur-slow) var(--bloo-ease-out)' }}
        />
      </svg>
      {children ? <div className="bui-ring-center">{children}</div> : null}
    </div>
  )
}
